import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import '@angular/localize/init';
import { Subject } from 'rxjs';
import { AppConfigService } from './services/app-config.service';
import { AuthService } from './services/auth.service';
import { AbstractComponent } from './shared/components/abstract-component';
import { IAppConfig } from './shared/interfaces/app-config';
import { AppNotificationService } from './shared/services/app-notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent extends AbstractComponent implements OnInit, AfterViewInit {
  title = 'SEDMS-KendoUI';
  userLoaded: Subject<boolean> = new Subject<boolean>();
  user: any;
  authResult: any;
  public isDialogVisible: boolean = false;
  showDetails = false;
  location = window.location.href;
  referrer = document.referrer;
  userAgent = navigator.userAgent;
  screenResolution = `${screen.width}x${screen.height}`;
  @ViewChild('notificationContainer', { read: ViewContainerRef })
  public notificationContainer: ViewContainerRef
  config: IAppConfig;

  constructor(
    private authService: AuthService,
    private notificationService: AppNotificationService,
    private appConfigService: AppConfigService,
  ) {
    super();
    this.config = this.appConfigService.getConfig();
  }

  ngOnInit() {
    this.authService.completeAuthentication();
    this.setGoogleTag();
  }

  ngAfterViewInit() {
    this.notificationService.setNotificationContaier(this.notificationContainer);
  }

  private setGoogleTag(): void {
    if (this.config.googleTag && !this.isGoogleTagInjected()) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.config.googleTag}`;
      document.head.appendChild(gtagScript);

      const inlineScript = document.createElement('script');
      inlineScript.textContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', '${this.config.googleTag}');
      `;
      document.head.appendChild(inlineScript);
    }
  }

  private isGoogleTagInjected(): boolean {
    if (typeof (window as any).gtag === 'function') {
      return true;
    }
    return false;
  }

  public openDialog(): void {
    this.isDialogVisible = true;
  }

  public closeDialog(): void {
    this.isDialogVisible = false;
    this.showDetails = false;
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    this.showDetails = !this.showDetails;
  }

  afterOnDestroy(): void {
    // afterOnDestroy
  }
}
